// extracted by mini-css-extract-plugin
export default {"nav":"Overview_nav__Io6wg","item":"Overview_item__o3Jt5","active":"Overview_active__+vmiK"};